import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '../services/lang.service';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private lang: LangService) {
  }

  transform(value: any, pattern: string = 'yyyy/MM/dd'): any {
    const datePipe: DatePipe = new DatePipe(this.lang.currentLang);
    return datePipe.transform(value, pattern);
  }

}
